import { ItemIcon } from '../ItemIcon';
import { cn } from '../../utils/cn';
import { ATLAS_DEFAULT_CLUSTER } from '../../utils/atlasItemIcon';
import { objectLabel, objectNamespace } from '../../utils/logbook';

interface LogbookObjectProps {
  objectId: string;
  /** Cluster the evidence came from, so the icon resolves against the right pack atlas. */
  clusterId?: string | null;
  quantity?: number | null;
  className?: string;
}

/**
 * The `object_id` of an event, drawn as the thing it names.
 *
 * Objects are registry identifiers, so most resolve to an Atlas icon. Some never will: a menu type,
 * a `ftbteams:team` marker or an item from a mod that has since been removed. Those keep their
 * stored identifier, which stays searchable and is the honest thing to show.
 */
export const LogbookObject = ({ objectId, clusterId, quantity, className }: LogbookObjectProps) => {
  if (!objectId) return null;
  const namespace = objectNamespace(objectId);
  const drawable = Boolean(namespace) && !/^(ftbteams|ftbchunks|openpac|waystones|logbook|legacy)$/.test(namespace ?? '');

  return (
    <span className={cn('inline-flex items-center gap-1.5 min-w-0 align-middle', className)} title={objectId}>
      {drawable && (
        <ItemIcon clusterId={clusterId || ATLAS_DEFAULT_CLUSTER} itemId={objectId} displayMode="icon" className="w-4 h-4" />
      )}
      {quantity != null && quantity > 1 && (
        <span className="font-mono tabular-nums text-glass-300">{quantity.toLocaleString()}&times;</span>
      )}
      <span className="truncate text-white">{objectLabel(objectId)}</span>
    </span>
  );
};
